module.exports = __webpack_public_path__ + "static/media/京东logo.8d1122c1.jpg";